import {
  Box,
  ColumnLayout,
  FormField,
  SpaceBetween,
} from '@cloudscape-design/components';
import PPartDisplay from 'components/Projects/pPartDisplay';
import PropTypes from 'prop-types';
import React from 'react';

export default function PPartContent({ pPart, projectDocId }) {
  return (
    <SpaceBetween direction="vertical" size="s">
      <ColumnLayout columns={4}>
        <FormField label="Part ID">
          {pPart.partId}
        </FormField>
        <FormField label="Revision">
          {pPart.revision}
        </FormField>
        {pPart.material && (
          <FormField label="Material">
            {pPart.material}
          </FormField>
        )}

        <FormField label="Name">
          {pPart.name}
        </FormField>

        {pPart.instance && (
          <FormField label="Instance">
            {pPart.instance}
          </FormField>
        )}

        <FormField label="Type">
          {pPart.type}
        </FormField>

        {pPart.cavities?.length > 0 && (
          <FormField
            label="Cavities"
          >
            <Box>
              {pPart.cavities?.map((cavity) => cavity.name).join(', ')}
            </Box>
          </FormField>
        )}

        {pPart.stepType && (
          <FormField label="Step Type">
            {pPart.stepType}
          </FormField>
        )}

        {pPart.size && (
          <FormField label="Size">
            {pPart.size}
          </FormField>
        )}

        {pPart.flashGap && (
          <FormField label="Flash Gap">
            {pPart.flashGap}
          </FormField>
        )}

        {pPart.metadataArr?.length > 0 && (
          <FormField label="Metadata">
            <Box>
              {pPart.metadataArr?.map((meta) => (
                <div key={meta.key}>
                  <strong>
                    {meta.key}
                    :
                  </strong>
                  {' '}
                  {meta.value}
                </div>
              ))}
            </Box>
          </FormField>
        )}

        <FormField label="Notes">
          <PPartDisplay
            fieldName="notes"
            projectDocId={projectDocId}
            pPartDocId={pPart.id}
            fallbackMessage="N/A"
          />
        </FormField>
      </ColumnLayout>
    </SpaceBetween>
  );
}

PPartContent.propTypes = {
  pPart: PropTypes.shape({
    id: PropTypes.string.isRequired,
    partId: PropTypes.string.isRequired,
    revision: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    instance: PropTypes.number,
    cavities: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
    material: PropTypes.string,
    stepType: PropTypes.string,
    size: PropTypes.string,
    flashGap: PropTypes.string,
    notes: PropTypes.string,
    metadataArr: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }).isRequired,
  projectDocId: PropTypes.string.isRequired,
};
